<template>
  <div class="profile-header-nav">
    <b-navbar toggleable="md" type="light">
      <b-navbar-toggle
        :class="[
          'ml-auto',
          userData.permissions && !userData.permissions.permissions.length
            ? 'd-none'
            : '',
        ]"
        target="nav-text-collapse"
      >
        <feather-icon icon="AlignJustifyIcon" size="21" />
      </b-navbar-toggle>

      <b-collapse id="nav-text-collapse" is-nav>
        <b-tabs
          pills
          :class="[
            'profile-tabs mt-1 mt-md-0',
            userData.permissions && !userData.permissions.permissions.length
              ? 'd-xl-flex d-none'
              : '',
          ]"
          navWrapperClass="w-100"
          nav-class="mb-0 w-100"
        >
          <template #tabs-start>
            <b-nav-item
              role="presentation"
              :to="
                $route.path.includes('profile')
                  ? { name: 'profile-road-map' }
                  : {
                      name: 'users-profile-road-map',
                      params: { id: $route.params.id },
                    }
              "
              :active="
                $route.name === 'profile-road-map' ||
                $route.name === 'users-profile-road-map'
              "
              :exact-active-class="
                $route.path.includes('users') ? 'bg-info border-info' : ''
              "
              class="font-weight-bold"
            >
              <span class="d-none d-md-block">مسیر یادگیری</span>
              <feather-icon icon="RssIcon" class="d-block d-md-none" />
            </b-nav-item>
            <!-- <b-nav-item
              role="presentation"
              :to="
                $route.path.includes('profile')
                  ? { name: 'profile' }
                  : { name: 'user-detail', params: { id: $route.params.id } }
              "
              :active="
                $route.name === 'profile' || $route.name === 'user-detail'
              "
              :exact-active-class="
                $route.path.includes('users') ? 'bg-info border-info' : ''
              "
              class="font-weight-bold"
            >
              <span class="d-none d-md-block">مشخصات</span>
              <feather-icon icon="RssIcon" class="d-block d-md-none" />
            </b-nav-item> -->

            <b-nav-item
              v-if="$route.path.includes('profile')"
              :to="{ name: 'profile-shop' }"
              :exact-active-class="
                $route.path.includes('profile-shop')
                  ? 'bg-info border-info'
                  : ''
              "
              :active="$route.name === 'profile-shop'"
              role="presentation"
              class="font-weight-bold"
            >
              <span class="d-none d-md-block">دوره های آموزشی</span>
              <feather-icon icon="UsersIcon" class="d-block d-md-none" />
            </b-nav-item>
            <b-nav-item
              role="presentation"
              class="font-weight-bold"
              :to="
                $route.path.includes('profile')
                  ? { name: 'profile-courses' }
                  : { name: 'user-courses', params: { id: $route.params.id } }
              "
              :exact-active-class="
                $route.path.includes('users') ? 'bg-info border-info' : ''
              "
              :active="
                $route.name === 'profile-courses' ||
                $route.name === 'user-courses'
              "
            >
              <span class="d-none d-md-block">دوره های من</span>
              <feather-icon icon="UsersIcon" class="d-block d-md-none" />
            </b-nav-item>
            <b-nav-item
              role="presentation"
              class="font-weight-bold"
              :to="
                $route.path.includes('profile')
                  ? { name: 'profile-exercises' }
                  : { name: 'user-exercises', params: { id: $route.params.id } }
              "
              :exact-active-class="
                $route.path.includes('users') ? 'bg-info border-info' : ''
              "
              :active="
                $route.name === 'profile-exercises' ||
                $route.name === 'user-exercises'
              "
            >
              <span class="d-none d-md-block">تمرین ها</span>
              <feather-icon icon="InfoIcon" class="d-block d-md-none" />
            </b-nav-item>
            <b-nav-item
              v-if="
                $route.params.id
                  ? true
                  : userData.permissions &&
                    !userData.permissions.permissions.length
              "
              role="presentation"
              class="font-weight-bold"
              :to="
                $route.path.includes('profile')
                  ? { name: 'profile-paid-items' }
                  : {
                      name: 'user-paid-items',
                      params: { id: $route.params.id },
                    }
              "
              :exact-active-class="
                $route.path.includes('users') ? 'bg-info border-info' : ''
              "
              :active="
                $route.name === 'profile-paid-items' ||
                $route.name === 'user-paid-items'
              "
            >
              <span class="d-none d-md-block">فاکتور ها</span>
              <feather-icon icon="UsersIcon" class="d-block d-md-none" />
            </b-nav-item>
            <b-nav-item
              v-if="
                $route.params.id
                  ? true
                  : userData.permissions &&
                    !userData.permissions.permissions.length
              "
              role="presentation"
              class="font-weight-bold"
              :to="
                $route.path.includes('profile')
                  ? { name: 'profile-penalties' }
                  : {
                      name: 'user-penalties',
                      params: { id: $route.params.id },
                    }
              "
              :exact-active-class="
                $route.path.includes('users') ? 'bg-info border-info' : ''
              "
              :active="
                $route.name === 'profile-penalties' ||
                $route.name === 'user-penalties'
              "
            >
              <span class="d-none d-md-block">جریمه ها</span>
              <feather-icon icon="UsersIcon" class="d-block d-md-none" />
            </b-nav-item>
            <b-nav-item
              v-if="
                $route.params.id
                  ? true
                  : userData.permissions &&
                    !userData.permissions.permissions.length
              "
              role="presentation"
              class="font-weight-bold"
              :to="
                $route.path.includes('profile')
                  ? { name: 'profile-transactions' }
                  : {
                      name: 'user-transactions',
                      params: { id: $route.params.id },
                    }
              "
              :exact-active-class="
                $route.path.includes('users') ? 'bg-info border-info' : ''
              "
              :active="
                $route.name === 'profile-transactions' ||
                $route.name === 'user-transactions'
              "
            >
              <span class="d-none d-md-block">تراکنش ها</span>
              <feather-icon icon="UsersIcon" class="d-block d-md-none" />
            </b-nav-item>
            <b-nav-item
              v-if="$route.params.id"
              role="presentation"
              class="font-weight-bold"
              :to="
                $route.path.includes('profile')
                  ? { name: 'profile-audit-logs' }
                  : {
                      name: 'user-audit-logs',
                      params: { id: $route.params.id },
                    }
              "
              :exact-active-class="
                $route.path.includes('users') ? 'bg-info border-info' : ''
              "
              :active="
                $route.name === 'profile-audit-logs' ||
                $route.name === 'user-audit-logs'
              "
            >
              <span class="d-none d-md-block">گزارش فعالیت</span>
              <feather-icon icon="UsersIcon" class="d-block d-md-none" />
            </b-nav-item>
            <b-nav-item
              v-if="$route.params.id"
              role="presentation"
              class="font-weight-bold"
              :to="
                $route.path.includes('profile')
                  ? { name: 'profile-devices' }
                  : {
                      name: 'user-devices',
                      params: { id: $route.params.id },
                    }
              "
              :exact-active-class="
                $route.path.includes('users') ? 'bg-info border-info' : ''
              "
              :active="
                $route.name === 'profile-devices' ||
                $route.name === 'user-devices'
              "
            >
              <span class="d-none d-md-block">دستگاه ها</span>
              <feather-icon icon="UsersIcon" class="d-block d-md-none" />
            </b-nav-item>
          </template>

          <template #tabs-end>
            <b-nav-item
              role="presentation"
              class="font-weight-bold ml-auto"
              :to="
                $route.path.includes('profile')
                  ? { name: 'profile-edit' }
                  : { name: 'user-edit', params: { id: $route.params.id } }
              "
              :exact-active-class="
                $route.path.includes('users') ? 'bg-info border-info' : ''
              "
              :active="
                $route.name === 'profile-edit' || $route.name === 'user-edit'
              "
            >
              <feather-icon icon="EditIcon" class="d-block d-md-none" />
              <span class="font-weight-bold d-none d-md-block"
                >ویرایش مشخصات</span
              >
            </b-nav-item>
          </template>
        </b-tabs>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import {
  BNavbar,
  BNavbarToggle,
  BCollapse,
  BTabs,
  BNavItem,
  BButton,
} from "bootstrap-vue";
export default {
  computed: {
    userData() {
      return this.$store.state.auth.userData || {};
    },
  },
  components: {
    BTabs,
    BButton,
    BNavItem,
    BNavbar,
    BNavbarToggle,
    BCollapse,
  },
};
</script>
